import React, { useState } from 'react';
import Sidebar from '../Sidebar/Sidebar';
import './MainLayout.css';

/**
 * MainLayout - Layout principal de la aplicación
 * Incluye Sidebar y área de contenido
 */
const MainLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="app-layout">
      <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
      
      <main className="main-content">
        {children}
      </main>

      {/* Mobile Menu Button */}
      <button 
        className="mobile-menu-btn"
        onClick={toggleSidebar}
        aria-label="Toggle Menu"
      >
        <span className="menu-icon">☰</span>
      </button>
    </div>
  );
};

export default MainLayout;
